import {PracticeArea} from '@open-law/fab/shared-entities'

export const practiceAreaConstants: PracticeArea[] = [
    {
        id: 'commercialLaw',
        title: `Commercial Law`,
        description: ``,
        subPracticeAreasHash: {
            'admiralty': {
                id: 'admiralty',
                title: `Admiralty`,
                description: ``,
                parent: 'commercialLaw'
            },
            'appellateCommercial': {
                id: 'appellateCommercial',
                title: `Appellate`,
                description: ``,
                parent: 'commercialLaw'
            },
            'Aviation': {
                id: 'Aviation',
                title: `Aviation`,
                description: ``,
                parent: 'commercialLaw'
            },
            'bankingFinance': {
                id: 'bankingFinance',
                title: `Banking & Finance`,
                description: ``,
                parent: 'commercialLaw'
            },
            'bankruptcy': {
                id: 'bankruptcy',
                title: `Bankruptcy`,
                description: ``,
                parent: 'commercialLaw'
            },
            'buildingConstruction': {
                id: 'buildingConstruction',
                title: `Building & Construction`,
                description: ``,
                parent: 'commercialLaw'
            },
            'classActionsCommercial': {
                id: 'classActionsCommercial',
                title: `Class Actions`,
                description: ``,
                parent: 'commercialLaw'
            },
            'commercialArbitration': {
                id: 'commercialArbitration',
                title: `Commercial Arbitration`,
                description: ``,
                parent: 'commercialLaw'
            },
            'competition': {
                id: 'competition',
                title: `Competition`,
                description: ``,
                parent: 'commercialLaw'
            },
            'consumerCredit': {
                id: 'consumerCredit',
                title: `Consumer Credit`,
                description: ``,
                parent: 'commercialLaw'
            },
            'consumerLaw': {
                id: 'consumerLaw',
                title: `Consumer Law`,
                description: ``,
                parent: 'commercialLaw'
            },
            'contracturalDisputes': {
                id: 'contracturalDisputes',
                title: `Contractual Disputes`,
                description: ``,
                parent: 'commercialLaw'
            },
            'corporateInsolvency': {

                id: 'corporateInsolvency',
                title: `Corporate Insolvency`,
                description: ``,
                parent: 'commercialLaw'
            },
            'corporationsSecurities': {
                id: '',
                title: `Corporations & Securities`,
                description: ``,
                parent: 'commercialLaw'
            },
            'energyResources': {

                id: 'energyResources',
                title: `Energy & Resources`,
                description: ``,
                parent: 'commercialLaw'
            },
            'equityTrusts': {
                id: '',
                title: `Equity & Trusts`,
                description: ``,
                parent: 'commercialLaw'
            },
            'insurance': {
                id: 'insurance',
                title: `Insurance`,
                description: ``,
                parent: 'commercialLaw'
            },
            'privateInternationalLaw': {
                id: 'privateInternationalLaw',
                title: `Private International Law`,
                description: ``,
                parent: 'commercialLaw'
            },
            'realProperty': {
                id: 'realProperty',
                title: `Real Property`,
                description: ``,
                parent: 'commercialLaw'
            },
            'residentialRetailTenancies': {
                id: 'residentialRetailTenancies',
                title: `Residential & Retail Tenancies`,
                description: ``,
                parent: 'commercialLaw'
            },
            'sportsLaw': {
                id: 'sportsLaw',
                title: `Sports Law`,
                description: ``,
                parent: 'commercialLaw'
            },
            'superannuation': {
                id: 'superannuation',
                title: `Superannuation`,
                description: ``,
                parent: 'commercialLaw'
            },
            'taxation': {
                id: 'taxation',
                title: `Taxation`,
                description: ``,
                parent: 'commercialLaw'
            },
            'willsProbate': {
                id: 'willsProbate',
                title: `Wills & Probate`,
                description: ``,
                parent: 'commercialLaw'
            }
        },
        subPracticeAreas: [
            {
                id: '',
                title: `Admiralty`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Appellate`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Aviation`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Banking & Finance`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Bankruptcy`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Building & Construction`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Class Actions`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Commercial Arbitration`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Competition`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Consumer Credit`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Consumer Law`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Contractual Disputes`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Corporate Insolvency`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Corporations & Securities`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Energy & Resources`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Equity & Trusts`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Insurance`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Private International Law`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Real Property`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Residential & Retail Tenancies`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Sports Law`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Superannuation`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Taxation`,
                description: ``,
                parent: 'commercialLaw'
            },
            {
                id: '',
                title: `Wills & Probate`,
                description: ``,
                parent: 'commercialLaw'
            }

        ]
    },
    {
        id: 'criminalLaw',
        title: `Criminal Law`,
        description: ``,
        subPracticeAreasHash: {
            'WhiteCollarCrime': {
                id: 'WhiteCollarCrime',
                title: 'White Collar Crime',
                description: '',
                parent: 'criminalLaw'
            },
            'SummaryOffencesNSW': {
                id: `SummaryOffencesNSW`,
                title: `Summary Offences NSW`,
                description: ``,
                parent: 'criminalLaw'
            },
            'CommonwealthIndictableOffences': {
                id: `CommonwealthIndictableOffences`,
                title: `Commonwealth Indictable Offences`,
                description: ``,
                parent: 'criminalLaw'
            },
            'CareandProtection': {
                id: `CareandProtection`,
                title: `Care and Protection`,
                description: ``,
                parent: 'criminalLaw'
            },
            'IndependentChildren': {
                id: `IndependentChildren'sLawyer`,
                title: `Independent Children's Lawyer`,
                description: ``,
                parent: 'criminalLaw'
            },
            'NSWIndictableOffences': {
                id: `NSWIndictableOffences`,
                title: `NSW Indictable Offences`,
                description: ``,
                parent: 'criminalLaw'
            },
            'MentalHealthAdvocacy': {
                id: `MentalHealthAdvocacy`,
                title: `Mental Health Advocacy`,
                description: ``,
                parent: 'criminalLaw'
            },
            'DomesticandFamilyViolence': {
                id: `DomesticandFamilyViolence`,
                title: `Domestic and Family Violence`,
                description: ``,
                parent: 'criminalLaw'
            },
            'Indictableandcomplexmatters': {
                id: `Indictableandcomplexmatters`,
                title: `Indictable and complex matters`,
                description: ``,
                parent: 'criminalLaw'
            },
            'NSWAppellate': {
                id: `NSWAppellate`,
                title: `NSW Appellate`,
                description: ``,
                parent: 'criminalLaw'
            },
            'CommonwealthAppellate': {
                id: `CommonwealthAppellate`,
                title: `Commonwealth Appellate`,
                description: ``,
                parent: 'criminalLaw'
            }
        },
        subPracticeAreas: [
            {
                id: ``,
                title: `Summary Offences NSW`,
                description: ``,
                parent: 'criminalLaw'
            },
            {
                id: ``,
                title: `Commonwealth Indictable Offences`,
                description: ``,
                parent: 'criminalLaw'
            },
            {
                id: ``,
                title: `Care and Protection`,
                description: ``,
                parent: 'criminalLaw'
            },
            {
                id: ``,
                title: `Commonwealth Appellate`,
                description: ``,
                parent: 'criminalLaw'
            },
            {
                id: ``,
                title: `Independent Children's Lawyer`,
                description: ``,
                parent: 'criminalLaw'
            },
            {
                id: ``,
                title: `NSW Indictable Offences`,
                description: ``,
                parent: 'criminalLaw'
            },
            {
                id: ``,
                title: `Mental Health Advocacy`,
                description: ``,
                parent: 'criminalLaw'
            },
            {
                id: ``,
                title: `Domestic and Family Violence`,
                description: ``,
                parent: 'criminalLaw'
            },
            {
                id: ``,
                title: `Indictable and complex matters`,
                description: ``,
                parent: 'criminalLaw'
            },
            {
                id: ``,
                title: `NSW Appellate`,
                description: ``,
                parent: 'criminalLaw'
            },
            {
                id: 'WhiteCollarCrime',
                title: 'White Collar Crime',
                description: '',
                parent: 'criminalLaw'
            },
        ]
    },
    {
        id: 'employmentIndustrial',
        title: `Employment and Industrial Law`,
        description: ``,
        subPracticeAreasHash: {
            'Appellate': {
                id: `Appellate`,
                title: `Appellate`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            },
            'ConfidentialInformation': {
                id: `ConfidentialInformation`,
                title: `Confidential Information`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            },
            'Disciplinary': {
                id: 'Disciplinary',
                title: 'Disciplinary',
                description: '',
                parent: 'employmentIndustrial'
            },
            'Discrimination': {
                id: `Discrimination`,
                title: `Discrimination`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            },
            'Employment Contracts': {
                id: `Employment Contracts`,
                title: `Employment Contracts`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            },
            'Industrial Disputes': {
                id: `Industrial Disputes`,
                title: `Industrial Disputes`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            },
            'Public Sector Appeals': {
                id: `Public Sector Appeals`,
                title: `Public Sector Appeals`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            },
            'Restraint of Trade': {
                id: `Restraint of Trade`,
                title: `Restraint of Trade`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            },
            'Investigations': {
                id: `Investigations`,
                title: `Investigations`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            },
            'Statutory Employment Rights': {
                id: `Statutory Employment Rights`,
                title: `Statutory Employment Rights`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            },
            'Work Health & Safety': {
                id: `Work Health & Safety`,
                title: `Work Health & Safety`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            },
            'Workers Compensation': {
                id: `Workers Compensation`,
                title: `Workers Compensation`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            }
        },
        subPracticeAreas: [
            {
                id: ``,
                title: `Appellate`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            },
            {
                id: ``,
                title: `Confidential Information`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            },
            {
                id: ``,
                title: `Discrimination`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            },

            {
                id: 'Disciplinary',
                title: 'Disciplinary',
                description: '',
                parent: 'employmentIndustrial'
            },

            {
                id: ``,
                title: `Employment Contracts`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            },
            {
                id: ``,
                title: `Industrial Disputes`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            },
            {
                id: ``,
                title: `Public Sector Appeals`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            },
            {
                id: `Restraint of Trade`,
                title: `Restraint of Trade`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            },
            {
                id: ``,
                title: `Investigations`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            },
            {
                id: ``,
                title: `Statutory Employment Rights`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            },
            {
                id: ``,
                title: `Work Health & Safety`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            },
            {
                id: ``,
                title: `Workers Compensation`,
                description: ``,
                parent: 'employmentIndustrialLaw'
            }

        ]
    },

    {
        id: 'intellectualProperty',
        title: `Intellectual Property and Media Law`,
        description: ``,
        subPracticeAreas: [
            {
                id: ``,
                title: `Appellate`,
                description: ``,
                parent: 'intellectualProperty'
            },
            {
                id: ``,
                title: `Confidential Information`,
                description: ``,
                parent: 'intellectualProperty'
            },
            {
                id: ``,
                title: `Copyright & Designs`,
                description: ``,
                parent: 'intellectualProperty'
            },
            {
                id: ``,
                title: `Information Technology`,
                description: ``,
                parent: 'intellectualProperty'
            },
            {
                id: ``,
                title: `Media & Entertainment`,
                description: ``,
                parent: 'intellectualProperty'
            },
            {
                id: ``,
                title: `Patents`,
                description: ``,
                parent: 'intellectualProperty'
            },
            {
                id: ``,
                title: `Privacy & Data Protection`,
                description: ``,
                parent: 'intellectualProperty'
            },
            {
                id: ``,
                title: `Telecommunications`,
                description: ``,
                parent: 'intellectualProperty'
            },
            {
                id: ``,
                title: `Trade Marks`,
                description: ``,
                parent: 'intellectualProperty'
            },
            {
                id: ``,
                title: `Defamation`,
                description: ``,
                parent: 'intellectualProperty'
            }

        ]
    },
    {
        id: 'publicLaw',
        title: `Public Law`,
        description: ``,
        subPracticeAreas: [
            {
                id: '',
                title: `Administrative Law`,
                description: ``,
                parent: 'publicLaw'
            },
            {
                id: '',
                title: `Aged Care`,
                description: ``,
                parent: 'publicLaw'
            },
            {
                id: '',
                title: `Appellate`,
                description: ``,
                parent: 'publicLaw'
            },
            {
                id: '',
                title: `Civil & Human Rights`,
                description: ``,
                parent: 'publicLaw'
            },
            {
                id: '',
                title: `Commissions & Inquiries`,
                description: ``,
                parent: 'publicLaw'
            },
            {
                id: '',
                title: `Constitutional Law`,
                description: ``,
                parent: 'publicLaw'
            },
            {
                id: '',
                title: `Customs Laws`,
                description: ``,
                parent: 'publicLaw'
            },
            {
                id: '',
                title: `Discrimination`,
                description: ``,
                parent: 'publicLaw'
            },
            {
                id: '',
                title: `Extradition Law`,
                description: ``,
                parent: 'publicLaw'
            },
            {
                id: '',
                title: `Environment`,
                description: ``,
                parent: 'publicLaw'
            },
            {
                id: '',
                title: `Freedom of Information`,
                description: ``,
                parent: 'publicLaw'
            },
            {
                id: '',
                title: `Guardianship & Administration`,
                description: ``,
                parent: 'publicLaw'
            },
            {
                id: '',
                title: `Immigration`,
                description: ``,
                parent: 'publicLaw'
            },
            {
                id: '',
                title: `Judicial Review`,
                description: ``,
                parent: 'publicLaw'
            },
            {
                id: '',
                title: `Licensing`,
                description: ``,
                parent: 'publicLaw'
            },
            {
                id: '',
                title: `Native Title`,
                description: ``,
                parent: 'publicLaw'
            },
            {
                id: '',
                title: `Planning & Local Government`,
                description: ``,
                parent: 'publicLaw'
            },
            {
                id: '',
                title: `Privacy`,
                description: ``,
                parent: 'publicLaw'
            },
            {
                id: '',
                title: `Public International Law`,
                description: ``,
                parent: 'publicLaw'
            },
            {
                id: '',
                title: `Taxation`,
                description: ``,
                parent: 'publicLaw'
            },
            {
                id: '',
                title: `White Collar Crime`,
                description: ``,
                parent: 'publicLaw'
            }
        ]
    },

// {
//
// }, // Add class actions top level

    {
        id: 'tortLaw',
        title: `Tort Law`,
        description: ``,
        subPracticeAreas: [
            {
                id: ``,
                title: `Appellate`,
                description: ``,
                parent: 'tortLaw'
            },
            {
                id: ``,
                title: `Class Actions`,
                description: ``,
                parent: 'tortLaw'
            },
            {
                id: ``,
                title: `Commissions & Inquiries`,
                description: ``,
                parent: 'tortLaw'
            },
            {
                id: ``,
                title: `Common Law`,
                description: ``,
                parent: 'tortLaw'
            },
            {
                id: ``,
                title: `Defamation`,
                description: ``,
                parent: 'tortLaw'
            },
            {
                id: ``,
                title: `Inquests`,
                description: ``,
                parent: 'tortLaw'
            },
            {
                id: ``,
                title: `Major Torts`,
                description: ``,
                parent: 'tortLaw'
            },
            {
                id: ``,
                title: `Negligence`,
                description: ``,
                parent: 'tortLaw'
            },
            {
                id: ``,
                title: `Personal Injury`,
                description: ``,
                parent: 'tortLaw'
            },
            {
                id: ``,
                title: `Product Liability`,
                description: ``,
                parent: 'tortLaw'
            },
            {
                id: ``,
                title: `Professional Negligence`,
                description: ``,
                parent: 'tortLaw'
            }

        ]
    }
]


// TODO:
// Change Members and Licensees

// Add default on page load to sort by `last name`

// Add listing

// Landing Page for each practice area, filter-by sub-practice areas -
